import { useEffect, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";

export type GetAutocompleteResult = {
    userId: string,
    fullName: string,
    userType?: string,
    isSageUser?: boolean,
    contractorId?: number
};

type WorkItemResult = [
    GetAutocompleteResult[] | null,
    boolean,
    string | null,
    React.Dispatch<React.SetStateAction<GetAutocompleteResult[] | null>>
];

const useBulkOperationAutoCompleteResource: (selectedResponsibilityIds: number[], workspaceIds: number[], searchString: string) => WorkItemResult = (selectedResponsibilityIds, workspaceIds, searchString) => {
    const [result, setBulkOperationResources] = useState<GetAutocompleteResult[] | null>(null);
    const [error, setErrorResources] = useState<string | null>(null);
    const [loading, setLoadingResources] = useState<boolean>(true);
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        const controller = new AbortController();
        const fetchTasks = async () => {
            if (user && user.id_token && searchString && workspaceIds?.length > 0 && selectedResponsibilityIds) {
                setBulkOperationResources(null);
                setLoadingResources(true);
                try {

                    const resp = await fetcher(`/api/v3/bulkupdate/workitem/search-user-by-workspace-responsibility?s=${searchString}&rs=${selectedResponsibilityIds.join(',')}&ws=${workspaceIds.join(',')}`, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json();
                    setBulkOperationResources(data.users);
                } catch (err) {
                    // TODO: 
                } finally {
                    setLoadingResources(false);
                }
            } else {
                setLoadingResources(true);
                setBulkOperationResources([]);
                setLoadingResources(false);
            }
        };
        fetchTasks()
            .catch((err) => { });

        return () => {
            controller.abort();
            setLoadingResources(false);
        };
    }, [selectedResponsibilityIds, workspaceIds, searchString]);

    return [
        result,
        loading,
        error,
        setBulkOperationResources
    ];
};

export default useBulkOperationAutoCompleteResource;